import {createAsyncThunk, createDraftSafeSelector, createSlice} from '@reduxjs/toolkit'
import { AppState } from '../store/app-state'


export const fetchUser = createAsyncThunk(
  'user/fetchUser',
  async (_: void, { getState, dispatch }) => {
    const results = await fetch('/api/v2/user/appconfig');
    const data = await results.json();

    return data;
  },
);

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    user: null,
  },
  reducers: {
    loadUser: (state, { payload }) => {
      state.user = payload.user
      state.user.extra = payload.extra
    },
    resetUser: (state) => {
      return {
        ...state,
        user: null,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUser.fulfilled, (state, action) => {
      state.user = action.payload
      // state.user.extra = action.payload.extra
    })
    builder.addCase(fetchUser.rejected, (state, action) => {
      state.user = null
    })
  }
})

export const { loadUser } = userSlice.actions

export const userState = (state: AppState) => state.user;

export const userSelector = createDraftSafeSelector(
  userState,
  (state) => state.user,
);

export default userSlice.reducer
